<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5 class="dashboard-title">Skills Passport Details</h5>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="goBack">Back</button>
        </div>
      </div>

      <SkillsPassportCard
        :PassportDetails="skillsPassport"
        :Search="true"
        :ChartOptions="skillsPassport.ChartOptions"
        :BtnLoading="btnLoading"
        @save-skills-passport="saveSkillsPassport"
      >
      </SkillsPassportCard>
    </div>

    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import SkillsPassportCard from "../../../components/SkillsPassportCard.vue";
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    SkillsPassportCard,
    TSLoading
  },
  created() {
    this.onetCode = this.$route.params.onetcode;
    this.loading = true;

    var selectedCurrency = this.$i18n.messages[localStorage.getItem("locale")];
    var exrate = this.$ExchangeRates?.data.filter(r => r.base == "USD")[0]
      ?.rates[selectedCurrency.currency];
    var symbol = selectedCurrency.currency === "USD" ? "$" : "£";

    this.$store
      .dispatch("skillspassport/getCareerDetails", this.onetCode)
      .then(res => {
        this.skillsPassport = res;
        this.passportLabels = [];
        this.chartOptions = {};
        const less = `10% of workers earn ${symbol}${(
          this.skillsPassport.jobOutlook.salary.annual_10th_percentile * exrate
        ).toLocaleString("en-US")} or less`;
        const ave = `Workers on average earn ${symbol}${(
          this.skillsPassport.jobOutlook.salary.annual_median * exrate
        ).toLocaleString("en-US")}`;
        const more = `10% of workers earn ${symbol}${(
          this.skillsPassport.jobOutlook.salary.annual_90th_percentile * exrate
        ).toLocaleString("en-US")} or more`;
        this.passportLabels.push(less);
        this.passportLabels.push(ave);
        this.passportLabels.push(more);

        this.chartOptions.labels = this.passportLabels;
        this.skillsPassport.ChartOptions = this.chartOptions;
        this.loading = false;

        var legendPosition = window.innerWidth > 759 ? "right" : "bottom";
        this.chartOptions.legend.position = legendPosition;
      });
  },
  data() {
    return {
      btnLoading: false,
      loading: false,
      onetCode: null,
      skillsPassport: {},
      api: "",
      passportLabels: [],
      chartOptions: {
        legend: {
          position: "bottom",
          horizontalAlign: "left"
        },
        labels: [],
        chart: {
          type: "donut",
          height: "auto",
          width: "auto"
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: "45%"
            }
          }
        }
      }
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    saveSkillsPassport(passportDetails) {
      this.loading = true;
      this.$store
        .dispatch(
          "skillspassport/checkSkillsPassport",
          passportDetails.taskDescription.code
        )
        .then(res => {
          if (res) {
            this.$message.error(`Skills passport already exist!`);
            this.loading = false;
            this.btnLoading = false;
          } else {
            this.loading = false;
            this.$confirm(
              `<p style="text-align:center;padding-bottom:20px;">Are you sure you want to select <span style="font-weight: bold;">${passportDetails.taskDescription.title}</span> to be one of your skill passport?</p>`,
              "Warning",
              {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning",
                dangerouslyUseHTMLString: true,
                center: true
              }
            ).then(() => {
              this.loading = true;
              this.$store
                .dispatch("skillspassport/saveSkillsPassport", passportDetails)
                .then(res => {
                  if (res) {
                    this.$message.success(`Skills passport saved!`);
                    this.btnLoading = false;
                    if (
                      this.$store.state.account.current_user.roles.includes(
                        "Apprentice"
                      )
                    ) {
                      this.$router.push({ name: "ApprenticeSearchCareer" });
                    } else {
                      this.$router.push({ name: "JobSeekerSearchCareer" });
                    }
                  } else {
                    this.$message.error(`Skills passport already exist!`);
                    this.btnLoading = false;
                  }
                  this.loading = false;
                })
                .catch(res => {});
            });
          }
        });
    }
  }
};
</script>
